
import { A2AAgent } from '../types';

export const executiveAgents: A2AAgent[] = [
  {
    id: 'executive-agent',
    name: 'BrigAI',
    capabilities: ['task-coordination', 'agent-orchestration', 'conversation'],
    description: 'Executive AI assistant that can orchestrate specialized agents',
    isAvailable: true,
    category: 'executive',
    version: '1.0',
    interfaces: ['chat', 'task-delegation'],
    maxConcurrentTasks: 10
  }
];

